import { ConversationAPI, CustomerAPI, ClickAPI } from 'api'
import { userCanAccessOrgPlaybookReports } from 'utils/access'

export const createPlaybook = async type => (
  ConversationAPI.post(`playbooks?type=${type}`)
)

export const getPlaybookCounts = async type => {
  const onlyMine = !userCanAccessOrgPlaybookReports()
  return ConversationAPI.get(`playbooks/category-counts?onlyMine=${onlyMine}`)
}

export const getSignaturePlaybook = async () => ConversationAPI.get('playbooks?limited=true&reportType=SIGNATURE&status=ENABLED&status=DISABLED&status=ARCHIVED')

export const getPlaybookByID = async id => {
  return ConversationAPI.get(`playbooks/${id}`)
}

export const getReportDataByID = async (id, datesObj, playbookType='email') => {
  return ConversationAPI.get(`playbooks/${id}/${playbookType}_report`, {
    params: datesObj
  })
}

export const getPeopleInPlaybook = async (id, params) => (
  ConversationAPI.get(`playbooks/${id}/people_in_email`, {
    params: params
  })
)

export const getDollarsInfluenced = async (id, params) => (
  ConversationAPI.get(`playbooks/${id}/dollars_influenced`, {
    params: params
  })
)

export const getIntegrations = async data => (
  CustomerAPI.get(`integrations`)
)

export const getPersonInPlaybookDetails = async endUserIds => (
  CustomerAPI.post(`end_users/find`, { endUserIds })
)

export const getMeetingAgents = async (agents) => (
  CustomerAPI.get(`users`, {params: {
    userId: agents
  }})
)

export const unenrollUser = async payload => (
  ConversationAPI.post(`playbooks/unenroll`, payload)
)

export const getPlaybookGatesByType = async () => (
  ConversationAPI.get('playbooks/playbooks_by_gate')
)

export const getPlaybookSendProgress = async (playbookId) => (
  ConversationAPI.get(`playbooks/${playbookId}/email_send_progress`)
)

export const startStandardTrial = async (orgId) => (
  CustomerAPI.post(`gates/start_standard_trial/${orgId}`)
)

export const getClickMapData = async (params) => (
  ClickAPI.get(`outbound/fetchclickmap/`, {
      ...params
  })
)
